module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-ro"
  }, [_c('div', {
    staticClass: "label-ro"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "value-ro"
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ee5eea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LayoutReadOnly.vue
// module id = 2601
// module chunks = 1